export function getNextURL() {
  if (typeof window !== 'undefined') return ''
  return getNextServerURL()
}

export function getNextServerURL() {
  const VERCEL_URL = process.env.VERCEL_URL

  if (VERCEL_URL) return `https://${VERCEL_URL}`

  return 'http://localhost:3000'
}
